const targetNode = document.body
// Options for the observer (which mutations to observe)
const config = { attributes: false, childList: true, subtree: true };

// Callback function to execute when mutations are observed
const callback = (mutationList, observer) => {
  for (const mutation of mutationList) {
    const lockElements = document.querySelectorAll('.bss-lock-element');
    for (let i = 0; i < lockElements.length; i++) {
      const link = lockElements[i].querySelector('.bss-lock-message-element[href*="/account/login"]');
      const href = link.href;
      const checkout_url = href ? href.split('?checkout_url=')[1] : '';
      link.href = '/account/register?checkout_url=' + checkout_url;
    }
  }
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(targetNode, config);

